// @ts-check

// What Premium and Premium Plus include, in brief, as the iOS app's paywall
// and Premium page list them. The numbers are the plans' own, shared with the
// website's plan table (AccountPanelView2.tsx).

import * as sharedConfig from "./sharedConfig.js";
import { permissions } from "./subscriptionPlans.js";

/** The longest phrase Premium translates, in words (translateRouter.js) */
export const premiumPhraseWords = 12;

/** Written conversations a day on Premium */
export const premiumChatsPerDay = permissions.standard.chat;

/**
 * @typedef {{
 *   permissions: "standard" | "plus",
 *   name: string,
 *   features: string[],
 * }} Plan
 */

/** @type {Plan[]} */
export const plans = [
  {
    permissions: "standard",
    name: "Premium",
    features: [
      `Unlimited phrase translations, up to ${premiumPhraseWords} words long`,
      "Unlimited context explanations",
      "Context-aware translations",
      "Practice words from specific texts",
      `Written conversations (${premiumChatsPerDay} a day)`,
      "High quality voices for words and phrases",
      `Audio upload and transcription (${sharedConfig.audioUploadLimitPremium / 3600} hours)`,
    ],
  },
  {
    permissions: "plus",
    name: "Premium Plus",
    features: [
      "Everything in Premium",
      "A better AI model for translations, explanations and summaries",
      "Unlimited written conversations",
      "High quality voices for whole texts",
      `Audio upload and transcription (${sharedConfig.audioUploadLimitPremiumPlus / 3600} hours)`,
    ],
  },
];
